/* eslint-disable no-extend-native */
// Extend the String prototype to include a toCamelCase method
String.prototype.toCamelCase = function () {
  return this.toLowerCase()
    .replace(/[^a-zA-Z0-9]+/g, " ")
    .trim()
    .split(" ")
    .map((word, index) =>
      index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join("");
};

// Extend the String prototype to include a toPascalCase method
String.prototype.toPascalCase = function () {
  return this.toCamelCase().charAt(0).toUpperCase() + this.slice(1);
};
